import { MessageToMerchant } from "../remoteAction";

export type ElementResizedAction = MessageToMerchant<"ELEMENT_RESIZED", string>;

export type sendElementResizedAction = ElementResizedAction;

export function sendElementResized(
  event: MouseEvent,
  configName: string,
  newStyle: {
    left: string;
    top: string;
    width: string;
    height: string;
  }
): sendElementResizedAction | null {
  event.stopPropagation();

  return {
    type: "SEND_MESSAGE_TO_MERCHANT",
    payload: {
      type: "ELEMENT_RESIZED",
      data: JSON.stringify({ configName, newStyle }),
    },
  };
}
